var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7157 0.0256736C4.62567 -0.404326 -0.404326 4.62567 0.0256736 10.7157C0.385674 16.0057 5.00567 19.9957 10.3057 19.9957H13.9957C14.5457 19.9957 14.9957 19.5457 14.9957 18.9957C14.9957 18.4457 14.5457 17.9957 13.9957 17.9957H10.3257C6.59567 17.9957 3.17567 15.5757 2.24567 11.9657C0.755674 6.16567 6.15567 0.755674 11.9557 2.25567C15.5757 3.17567 17.9957 6.59567 17.9957 10.3257V11.4257C17.9957 12.2157 17.2857 12.9957 16.4957 12.9957C15.7057 12.9957 14.9957 12.2157 14.9957 11.4257V10.1757C14.9957 7.66567 13.2157 5.40567 10.7357 5.05567C7.33567 4.56567 4.46567 7.50567 5.07567 10.9257C5.41567 12.8357 6.90567 14.4157 8.79567 14.8657C10.6357 15.2957 12.3857 14.7057 13.5357 13.5357C14.4257 14.7557 16.2057 15.3957 17.8357 14.7457C19.1757 14.2157 19.9957 12.8457 19.9957 11.4057V10.3157C19.9957 5.00567 16.0057 0.385674 10.7157 0.0256736ZM9.99567 12.9957C8.33567 12.9957 6.99567 11.6557 6.99567 9.99567C6.99567 8.33567 8.33567 6.99567 9.99567 6.99567C11.6557 6.99567 12.9957 8.33567 12.9957 9.99567C12.9957 11.6557 11.6557 12.9957 9.99567 12.9957Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedEmailIcon);
export default __webpack_public_path__ + "static/media/DeprecatedEmailIcon.2916cabc56bf0a728aed164f03aebbaf.svg";
export { ForwardRef as ReactComponent };